import styles from "./ManageTab.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useState } from "react";
import Card from "../Card";
import ChangeStatusModal from "../ChangeStatusModal";
import SyncErrorsModal from "DreamStream/Shared/SyncErrorsModal";
import RepairModal from "../RepairModal";
import SyncNowModal from "../SyncNowModal";

/**
 *
 * the contents of the Manage tab under the tab bar of the Group page
 */

export function ManageTab({
  status,
  lastSyncDate,
  lastSyncStatus,
  missingPluginsCount,
}) {
  const [changeStatusModalOpen, setChangeStatusModalOpen] = useState(false);
  const [statusState, setStatusState] = useState(status);
  function changeStatus(whitelist) {
    // TODO: call api method here to change status of this group
    setChangeStatusModalOpen(false);
    setStatusState(whitelist ? "Whitelist" : "Unwhitelist");
  }

  const [syncErrorsModalOpen, setSyncErrorsModalOpen] = useState(false);

  const [repairModalOpen, setRepairModalOpen] = useState(false);
  function repair() {
    // TODO: call api method here to repair
    alert("Repair called");
    setRepairModalOpen(false);
  }

  const [syncModalOpen, setSyncModalOpen] = useState(false);
  const [syncWithoutRefresh, setSyncWithoutRefresh] = useState(false);
  function sync(checked) {
    // TODO: call api method here
    alert("sync called with: " + checked);
    setSyncWithoutRefresh(checked);
    setSyncModalOpen(false);
  }

  return (
    <>
      <div className={styles.container}>
        <div className={styles.cardContainer}>
          <Card
            title="WHITELIST"
            buttonName="CHANGE"
            onClick={() => setChangeStatusModalOpen(true)}
            children={
              <div className={styles.grid}>
                <div className={styles.leftColumnItem}>Status:</div>
                <div className={styles.rightColumnItem}>{statusState}</div>
              </div>
            }
          />
        </div>
        <div className={styles.cardContainer}>
          <Card
            title="SYNC"
            buttonName="SYNC"
            onClick={() => setSyncModalOpen(true)}
            children={
              <div className={styles.grid}>
                <div className={styles.leftColumnItem}>Last Sync Date:</div>
                <div className={styles.rightColumnItem}>{lastSyncDate}</div>
                <div className={styles.leftColumnItem}>Last Sync Status:</div>
                <div className={styles.rightColumnItem}>
                  {lastSyncStatus}{" "}
                  <div
                    className={styles.viewSyncErrorButton}
                    onClick={() => setSyncErrorsModalOpen(true)}
                  >
                    View [ # ] sync errors
                  </div>
                </div>
              </div>
            }
          />
        </div>
        <div className={styles.cardContainer}>
          <Card
            title="META MISSING"
            buttonName="REPAIR"
            onClick={() => setRepairModalOpen(true)}
            children={
              <div className={styles.grid}>
                <div className={styles.leftColumnItem}>Missing Plugins:</div>
                <div className={styles.rightColumnItem}>
                  {missingPluginsCount}
                </div>
              </div>
            }
          />
        </div>

        <div className={styles.bold}>(SYNC RUNNING STATE)</div>

        <div className={styles.cardContainer}>
          <Card
            title="SYNC"
            buttonName="SYNC"
            buttonDisabled={true}
            onClick={() => setSyncModalOpen(true)}
            children={
              <div className={styles.grid}>
                <div className={styles.leftColumnItem}>Last Sync Date:</div>
                <div className={styles.rightColumnItem}>SYNC RUNNING</div>
                <div className={styles.leftColumnItem}>Last Sync Status:</div>
                <div className={styles.rightColumnItem}>Running</div>
              </div>
            }
          />
        </div>
      </div>

      <ChangeStatusModal
        isOpen={changeStatusModalOpen}
        onClose={() => setChangeStatusModalOpen(false)}
        onClick={changeStatus}
      />

      <SyncErrorsModal
        title={"VIEW SYNC ERRORS"}
        isOpen={syncErrorsModalOpen}
        onClose={() => setSyncErrorsModalOpen(false)}
        errors={[
          {
            timestamp: "2022-12-14T05:07:44.419Z",
            description:
              "wwgId: 153024 | Step 4: Verify DreamStream Account (MAXIMUM ATTEMPTS REACHED)",
            _id: "63995a2091e4418a7dd351e6",
          },
          {
            timestamp: "2022-12-14T05:07:44.419Z",
            description:
              "wwgId: 153024 | Step 4: Verify DreamStream Account (MAXIMUM ATTEMPTS REACHED)",
            _id: "63995a2091e4418a7dd351e6",
          },
        ]}
        date={"11/18/2022"}
        time="12:01 AM"
      />

      <RepairModal
        isOpen={repairModalOpen}
        onClose={() => setRepairModalOpen(false)}
        onClick={() => repair()}
      />

      <SyncNowModal
        isOpen={syncModalOpen}
        onClose={() => setSyncModalOpen(false)}
        onClick={sync}
        withoutRefresh={syncWithoutRefresh}
      />
    </>
  );
}

ManageTab.propTypes = {
  status: PropTypes.string,
  lastSyncDate: PropTypes.string,
  lastSyncStatus: PropTypes.string,
  missingPluginsCount: PropTypes.string,
};
